export default __webpack_public_path__ + "static/media/093-chevron-4.34391af1.png";